import * as d3 from 'd3-selection'
import * as colors from 'colors'
import { path as d3Path } from 'd3-path'

const TOP_RADIUS = 10 // Top stage rounded top corners

const BOTTOM_RADIUS = 10 // The final stage rounded bottom corners

/*
 * Draws a rouned tip between the two points, p0 and p1.
 */
const arrowTip = (p0, p1, control, context) => {
  let radius = 2
    , length = Math.sqrt(Math.pow(p0.x - control.x, 2) + Math.pow(p0.y - control.y, 2))

  let v0 = {
      x: control.x + (control.x - p0.x) / length * -radius,
      y: control.y + (control.y - p0.y) / length * -radius
    }
    , v1 = {
      x: control.x + (control.x - p1.x) / length * -radius,
      y: control.y + (control.y - p1.y) / length * -radius
    }

  // Draw a line to the shorter vector heading towards the control point
  context.lineTo(v0.x, v0.y)

  // Smooth curve around the control
  context.quadraticCurveTo(control.x, control.y, v1.x, v1.y)

  // Line to the next point
  context.lineTo(p1.x, p1.y)
}

/*
 * Draws the main stage element
 */
const main = d => {
  let path = d3Path()

  path.moveTo(d.topRadius * 2, 0)
  path.lineTo(d.arrowWidth + d.extension - d.topRadius * 2, 0)
  path.quadraticCurveTo(d.arrowWidth + d.extension, 0, d.arrowWidth + d.extension, d.topRadius * 2) // Rounded top right corner

  path.lineTo(d.arrowWidth + d.extension, d.height - d.bottomRightRadius * 2)

  // Control point for the curve
  let bottomRight = {
    x: d.arrowWidth + d.extension,
    y: d.height
  }

  if (d.extension) {
    path.quadraticCurveTo(bottomRight.x, bottomRight.y, d.arrowWidth + d.extension - d.bottomRightRadius * 2, d.height)
    // Draw a line horizontally to where the right side of the arrow starts
    path.lineTo(d.arrowWidth, d.height)
  } else {
    path.quadraticCurveTo(bottomRight.x, bottomRight.y, d.arrowWidth + d.extension - d.bottomRightRadius, d.height + d.bottomRightRadius / 2) // smooth the corner
    path.lineTo(d.arrowWidth - d.bottomRightRadius, d.height + d.bottomRightRadius / 2) // Not really needed but keeps points aligned for transitions
  }

  arrowTip({
    x: d.arrowWidth,
    y: d.height
  }, {
    x: d.bottomLeftRadius,
    y: d.height + d.bottomLeftRadius / 2 // For smoothing
  }, {
    x: d.arrowWidth / 2,
    y: d.height + d.tipHeight
  }, path)

  path.quadraticCurveTo(0, d.height, 0, d.height - d.bottomLeftRadius * 2)

  path.lineTo(0, d.topRadius * 2)

  path.quadraticCurveTo(0, 0, d.topRadius * 2, 0)

  return path.toString()
}

export default selection => {
  selection.each(function (d, i, all) {
    let total = all.length
      , stage = d3.select(this)
                  .selectAll('path')
                  .data((d, i) => {
                    let topRadius = Math.min(d.idx === 0 ? TOP_RADIUS : 0, d.height / 2)
                      , bottomRightRadius = d.idx === total - 1 ? (d.extension ? TOP_RADIUS : BOTTOM_RADIUS) : 0
                      , bottomLeftRadius = d.idx === total - 1 ? BOTTOM_RADIUS : 0

                    if (bottomRightRadius > d.height / 2) {
                      bottomRightRadius = d.height / 2
                    }
                    if (bottomLeftRadius > d.height / 2) {
                      bottomLeftRadius = d.height / 2
                    }
                    if (bottomLeftRadius > d.tipHeight) {
                      // Prevent the left radius extending below the tip
                      bottomLeftRadius = 0
                    }

                    let dimensions = {
                        arrowWidth: d.arrowWidth,
                        extension: d.extension,
                        topRadius,
                        bottomRightRadius,
                        bottomLeftRadius,
                        height: d.height,
                        tipHeight: d.tipHeight,
                        fill: `url(#process-colored-gradient-${d.color})`
                      }
                      , paths = [dimensions]

                    if (bottomRightRadius) {
                      // Bottom stage has an extra path for the shadow
                      paths.unshift(Object.assign({}, dimensions, {
                        fill: colors.adjustLightness(colors.lookup(d.color), -15),
                        class: `${d.color} shadow`,
                        shadow: true
                      }))
                    }

                    return paths
                  })

    stage.exit().remove()

    stage = stage.enter()
                 .append('path')
                 .merge(stage)

    stage.attr('fill', d => d.fill)
         .attr('class', d => d.class)
         .attr('d', main)

    stage.filter(d => d.shadow)
         .attr('transform', d => {
           let offset = 10
           if (d.height * .3 < 10) {
            // We don't have enough space to show the shadow
            offset = 0
           }
           return `translate(0, ${offset})`
         })
  })
}
